var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C77AC4",
    d: "M10.59 6.173c1.063.593 1.067 1.338 0 2.007l-8.242 5.56c-1.035.552-1.739.225-1.813-.97L.5 1.135C.477.034 1.385-.277 2.25.251l8.34 5.922Z"
  })));
};
export default SvgPlay;